import React from "react";
import { fileUrl } from "@/lib/api";
import { X, Film } from "lucide-react";

export function FilePreview({ file, onRemove, size = "md" }) {
  const dims = size === "sm" ? "h-16 w-16" : "h-24 w-24";
  return (
    <div className={`relative ${dims} overflow-hidden rounded-md border border-slate-200 bg-slate-50`}>
      {file.is_video ? (
        <div className="flex h-full w-full items-center justify-center bg-slate-800">
          <Film className="h-6 w-6 text-white" />
        </div>
      ) : (
        <img
          src={fileUrl(file.id)}
          alt={file.original_filename}
          className="h-full w-full object-cover"
        />
      )}
      {onRemove && (
        <button
          type="button"
          onClick={() => onRemove(file)}
          className="absolute right-1 top-1 rounded-full bg-black/60 p-0.5 text-white hover:bg-black"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );
}
